import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Autoplay, EffectFade, Navigation } from 'swiper';
import 'swiper/swiper-bundle.min.css';
import './style.css';

function Banner(props) {
    SwiperCore.use([Autoplay, EffectFade, Navigation])
    const [banners, setBanners] = useState([]);
    useEffect(() => {
        if (props.langType === 'kg') {
            getBanners('ky');
        } else {
            getBanners('ru');
        }
    }, [props.langType]);

    async function getBanners(lang) {
        const {data} = await axios.get(`https://strapi-dev.beeline.kg/v4/api/nomer-beeline-kg?locale=${lang}&populate=banner.desktop&populate=banner.mobile`);
        setBanners(data.data.attributes.banner);
    };

    return (
        <div className={`banner${banners.length === 0 ? 'm-0' : ''}`}>
            <div className="banner__container">
                <Swiper
                    spaceBetween={20}
                    slidesPerView={1}
                    autoplay={{delay: 3000,disableOnInteraction: false,}}
                    speed={1000}
                    modules={[EffectFade, Autoplay]}
                    effect="fade"
                    fadeEffect={{
                        crossFade: true,
                    }}
                    navigation={banners.length > 1 ? true : false}
                >
                    {
                        banners.map((item) => (
                            <SwiperSlide key={item.id} className="banner__item">
                                <a href={item.link} className="banner__link">
                                    <img src={'https://strapi-dev.beeline.kg/v4' + item.desktop.data.attributes.url} alt="Картинка" className="banner__img" loading="lazy"/>
                                    <img src={'https://strapi-dev.beeline.kg/v4' + item.mobile.data.attributes.url} alt="Картинка" className="banner__img-mob" loading="lazy"/>
                                </a>
                            </SwiperSlide>
                        ))
                    }
                </Swiper>
            </div>
        </div>
    )
}

const mapStateToProps = state => {
    return {
      langType: state.language.type
    };
};

export default connect(mapStateToProps)(Banner);

  